import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ClassificationService } from './../../../services/classification/classification.service';
import { LoyaltyReservationsService } from './../../../services/loyalty/loyalty-reservations.service';
import { SelectItem } from 'primeng/components/common/api';
import { ProvinceService } from './../../../services/province/province.service';
import { CountryService } from './../../../services/country/country.service';
import { CustomerInfoService } from './../../../services/customer/customerinfo.service';
import { mgCustomer, CustomerListModel, CustomerBasicInfo, mgCustomerCompany } from './../../../models/customer.model';
import { Report } from './../../../models/report.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import * as XLSX from 'xlsx';
import { ApiBlacklistCardModel } from '../../../models/api-blacklist-card.model';
import { CustomerCardListModel } from '../../../models/customer-cards.model';
import { Card } from '../../../models/loyalty-card.model';
import { Channel } from '../../../models/loyalty-channel.model';
import { Param } from '../../../models/loyalty-param.model';
import { Reason } from '../../../models/loyalty-reason.model';
import { ApiMethods, Permission, PermissionConfiguration, PermissionConfigurationBase } from '../../../models/permission.model';
import { SubstituteCardModel } from '../../../models/substitute-card.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { CustomerCardService } from '../../../services/customer/customer-card.service';
import { LoyaltyCardService } from '../../../services/loyalty/loyalty-card.service';
import { LoyaltyChannelService } from '../../../services/loyalty/loyalty-channel.service';
import { LoyaltyParamsService } from '../../../services/loyalty/params.service';
import { LoyaltyReasonService } from '../../../services/loyalty/reason.service';
import { PermsService } from '../../../services/utils/perms.service';
import { StoreCommonService } from './../../../services/store/store-common.service';
import { CalendarTranslateService } from './../../../modules/UIKit/services/calendarTranslate.service';
import { CommonService } from './../../../services/utils/common.service';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { CustomersService } from 'app/services/customer/customers.service';
import { CustomerOblivionService } from 'app/services/customer/customer-oblivion.service';

declare var Stimulsoft: any;
declare var $: any;

type AOA = any[][];

@Component({
  selector: 'app-loyalty-card',
  templateUrl: './loyalty-card.component.html',
  styleUrls: ['./loyalty-card.component.css']
})
export class LoyaltyCardComponent implements OnInit {

  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  numberFilter = KontableComponent.NumberFilter;
  selectFilter = KontableComponent.SelectFilter;
  columsTitles: any;
  totalRecords = 0;
  cards: Array<Card>;
  renderTable: boolean;
  viewImportDialog: boolean;
  selectedBlackListReason: any;
  basicInfo: CustomerBasicInfo;
  listChannels = new Array<{ value: string, label: string }>();
  listReasons = new Array<{ value: string, label: string }>();
  listParams = new Array<{ value: string, label: string }>();
  listStates: Array<{label: string, value: string}>;
  listBlacklist: Array<{label: string, value: string}>;
  blacklistReasons = new Array<{ value: number, label: string }>();
  channels = new Map<string, Channel>();
  reasons = new Map<string, Reason>();
  params = new Map<string, Param>();
  newDataAvailable = false;
  cardNotAvailable = false;
  stringaEsito = '';
  form: any;
  srcBarcode: SafeResourceUrl = null;
  showBarcodeModal: boolean = false;


  /*** per il download del modulo da stampare ***/
  show = {
    downloadSubstituteModule: false,
    substitutionOk: false
  }
  file: File = null;
  provinces: SelectItem[] = [];
  customerInfo: any;
  viewer: any;
  pdfReport: Report;
  translations: any;
  card: CustomerCardListModel;
  customer:mgCustomer;
  barcodeCardNoOld: string = '';
  barcodeCardNoNew: string = '';
  settore: SelectItem[] = [];
  customerType: string = "";
  customerAzienda:mgCustomerCompany;

  public cardPermission: Permission;
  public cardsModal: CustomerCardListModel[];

  private blacklistFile: File = null;
  private blacklistData: AOA;
  private blacklisted: string[];

  public showReplaceModal = false;
  public showBlackListModal = false;
  public showDomiciliationModal = false;
  public showMovementForm = false;
  private cardToReplace: Card;
  public movementCardId = 0;
  public newCardReplace;
  private cardToBlacklistId;
  private cardToBlacklistNo;


  /********************** PERMESSI UTENTE *************************/

  // Apre la scheda cliente inviando anche il card number nell'url, permettendo di richiamare la cardInfo
  public mdmCardPermission = false;

  // Visualizza tasto user per accesso a scheda cliente
  public cardCustomerPermission = false;

  // Visualizza tasto edit per modifica dati carta
  public editCardPermission = false;

  // Visualizza tasto import blacklist
  public blacklistImportPermission = false;

  // Visualizza tasto di aggiunta carte ed i dati del cliente
  public addCardPermission = false;

  // Visualizza i tasti di sostituzione e messa in blacklist
  public cardOperationsPermission = false;

  // Visualizza tasto dettagli carta
  public cardViewPermission = false;

  // Visualizza tasto movimenti carta
  public cardMovementPermission = false;

  // Visualizza tasto report
  public cardExportPermission = false;

  // Visualizza tasto download file Excel
  public cardExportExcelPermission = false;

  // Abilita il download del file Excel
  public cardDownloadPermission = false;

  // Disabilita il filtraggio della table per singola colonna
  public staticTable = false;

  // Abilita il download del modulo da firmare
  public mgPermission = false;

  // Visualizza i pulsanti relativi ai saldi
  public reservationPermission = false;

  // Abilitia il pulsante per obliare il cliente
  public customerOblivionPermission = false;

  // Nasconde il tasto di sostituzione carta
  public cardHideSubtituteOperationsPermission = false;

  /****************************************************************/


  /*** for domiciliation ***/
  public filteredStoresByChannel;
  public currentStore;
  public selectedCard;

  private confirmationMsg: string;
  private koMsg: string;
  public substitutionDisabled = {
    cardSelected: false,
    reasonSelected: false
  };

  public flgDplStates: Array<{label: string, value: string}> = [
    {label: '0', value: '0'},
    {label: '1', value: '1'}
  ];

  public flgStates: Array<{label: string, value: string}> = [];

  public flagBlackListTitle: string;

  // In caso l'utente non abbia le permission per la sostituzione delle carte, dovrà inserire i propri dati
  public userWithoutPermissions: { surname: string, name: string, birthDate: string } = { surname: '', name: '', birthDate: '' };

  extSearchResult: any;
  filterDateCard: Date;
  dateFilter = KontableComponent.DateFilter;
  @ViewChild('table') table: any;

  constructor (
    private translate: TranslateService,
    private router: Router,
    private permSrv: PermsService,
    public cardService: LoyaltyCardService,
    private channelService: LoyaltyChannelService,
    private reasonService: LoyaltyReasonService,
    private paramService: LoyaltyParamsService,
    private notifyService: MessageService,
    private customerCardService: CustomerCardService,
    private customerOblivionService: CustomerOblivionService,
    private svcStores: StoreCommonService,
    private tService: TranslateService,
    //private svcNotification: MessageService,
    private confirmationService: ConfirmationService,
    public calendarTranslateService: CalendarTranslateService,
    private srvCustomer: CustomersService,
    private commonService: CommonService,
    private srvInfoCust: CustomerInfoService,
    private srvStoreCommon: StoreCommonService,
    private srvCountry: CountryService,
    private srvProvince: ProvinceService,
    private srvLoyaltyReservations: LoyaltyReservationsService,
    private classificationService: ClassificationService,
    private sanitizer: DomSanitizer
  ) {

  }

  ngOnInit() {

    this.listChannels = [];
    this.listReasons = [];
    this.listParams = [];
    this.listStates = [];
    this.listBlacklist = [];

    this.listChannels.push({value: null, label: 'All'});
    this.listReasons.push({value: null, label: 'All'});
    this.listParams.push({value: null, label: 'All'});


    const translateObs = this.translate.get([
      'common.all',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended',
      'card.active',
      'card.deleted',
      'card.blacklist',
      'card.confirmSubstitution',
      'card.substitutionKo',
      'reportMg.card_title',
      'reportMg.name_title',
      'reportMg.surname_title',
      'reportMg.fiscalcode_title',
      'reportMg.birthdate_title',
      'reportMg.email_title',
      'reportMg.cellphone_title',
      'reportMg.street_title',
      'reportMg.localita_title',
      'reportMg.province_title',
      'reportMg.zipcode_title',
      'reportMg.informativa_title',
      'reportMg.consenso1_title3',
      'reportMg.consenso2_title3',
      'reportMg.consenso_title_yes',
      'reportMg.consenso_title_no',
      'reportMg.currentdate_title',
      'reportMg.substitute_title',
      'reportMg.sign_title',
      'reportMgCompany.card_title',
      'reportMgCompany.companyname_title',
      'reportMgCompany.pivafiscalcode_title',
      'reportMgCompany.officeemail_title',
      'reportMgCompany.officemobile_title',
      'reportMgCompany.area_title',
      'reportMgCompany.fullname_title',
      'reportMgCompany.fiscalcode_title',
      'reportMgCompany.street_title',
      'reportMgCompany.localita_title',
      'reportMgCompany.province_title',
      'reportMgCompany.zipcode_title',
      'reportMgCompany.informativa_title',
      'reportMgCompany.consenso1_title3',
      'reportMgCompany.consenso2_title3',
      'reportMgCompany.consenso_title_yes',
      'reportMgCompany.consenso_title_no',
      'reportMgCompany.currentdate_title',
      'reportMgCompany.sign_title',
      'reportMgCompany.substitute_title',
      'upload.download_error',
      'card.substitution_ok'
    ]);


    //verifica permission customer
    this.permSrv.getCustomerPermission().subscribe((permissions: Permission[]) => {
      permissions.forEach((perm: Permission) => {
        switch (perm.operationName) {
          case 'customer-mg':
            if (perm.allowsGET) this.mgPermission = true;
            break;
          case 'customer-oblivion':
            if (perm.allowsPUT) this.customerOblivionPermission = true;
            break;
        }
      });
    });

    // Verifica delle permission
    this.permSrv.getLoyaltyPermission().subscribe((permissions: Permission[]) => {
      permissions.forEach((perm: Permission) => {
        switch (perm.operationName) {
          case 'card-table-static':
            if (perm.allowsGET) this.staticTable = true;
            break;
          case 'cards':
            this.cardPermission = perm;
            if (perm.allowsPOST) this.addCardPermission = true;
            if (perm.allowsPUT) this.cardOperationsPermission = true;
            break;
          case 'card-mdm':
            if (perm.allowsGET) this.mdmCardPermission = true;
            break;
          case 'card-customer':
            if (perm.allowsGET) this.cardCustomerPermission = true;
            break;
          case 'card-modify-btn':
            if (perm.allowsGET) this.editCardPermission = true;
            break;
          case 'import-blacklist-btn':
            if (perm.allowsPOST) this.blacklistImportPermission = true;
            break;
          case 'card-view-btn':
            if (perm.allowsGET) this.cardViewPermission = true;
            break;
          case 'card-add-movement-btn':
            if (perm.allowsPOST) this.cardMovementPermission = true;
            break;
          case 'card-export':
            if (perm.allowsGET) this.cardExportPermission = true;
            break;
          case 'card-export-excel':
            if (perm.allowsGET) this.cardExportExcelPermission = true;
            break;
          case 'card-download':
            if (perm.allowsGET) this.cardDownloadPermission = true;
            break;
          case 'reservation':
            if (perm.allowsGET) this.reservationPermission = true;
            break;
          case 'card-substitute-hide-btn':
            if (perm.allowsPUT) this.cardHideSubtituteOperationsPermission = true;
            break;
        }
      });
    },
    err => console.log(err),
    () => {
      let obChannel: Observable<any>;
      let obParam: Observable<any>;
      let obReason: Observable<any>;
      let obReasonBlacklist: Observable<any>;

      obChannel = this.channelService.list();
      obParam =  this.paramService.list(null, null, [{key: 'param_group', value: 'CardType'}]);
      obReason = this.reasonService.list();
      obReasonBlacklist = this.cardService.getReasonList({paramKey: LoyaltyCardService.REASON_LIST_BLACKLIST_TYPE, flg_state: 0});

      Observable.zip(
        obChannel,
        obParam,
        obReason,
        translateObs,
        obReasonBlacklist,
        ).subscribe((
          [
            resChannel,
            resParam,
            resReason,
            t,
            resReasonBlacklist,
          ]) => {

          this.translations = t;

          this.listStates.push({label: t['common.all'], value: null});
          this.listStates.push({label: t['common.status_notDeleted'], value: '0'});
          this.listStates.push({label: t['common.status_onlyDeleted'], value: '1'});
          this.listStates.push({label: t['common.status_onlySuspended'], value: '2'});

          this.listBlacklist.push({label: t['common.all'], value: null});
          this.listBlacklist.push({label: t['card.blacklist'], value: '1'});
          this.listBlacklist.push({label: t['card.active'], value: '0'});

          this.flgDplStates.push({label: t['common.all'], value: null});

          this.flgStates.push({label: t['common.all'], value: null});
          this.flgStates.push({label: t['card.deleted'], value: '1'});
          this.flgStates.push({label: t['card.active'], value: '0'});

          this.confirmationMsg = t['card.confirmSubstitution'];
          this.koMsg = t['card.substitutionKo'];

          this.flagBlackListTitle = t['card.active'] + ' / ' + t['card.blacklist'];

          for (const channel of resChannel.data) {
            this.channels.set(channel.id, channel);
            this.listChannels.push({
              value: channel.channelDescription,
              label: channel.channelDescription
            });
          }

          for (const param of resParam.data) {
            this.params.set(param.id.toString(), param);
            this.listParams.push({
              value: param.description,
              label: param.description
            });
          }

          for (const reason of resReason.data) {
            this.reasons.set(reason.id.toString(), reason);
            this.listReasons.push({
              value: reason.id.toString(),
              label: reason.description
            });
          }

          for (const paramReason of resReasonBlacklist.data) {
            this.blacklistReasons.push({
              label: paramReason.description,
              value: paramReason.id
            });
          }

          if (this.blacklistReasons.length > 0) {
            this.selectedBlackListReason = this.blacklistReasons[0].value;
          }

          this.renderTable = true;
        }
      );
    }
    );

  }
  onClickVisualizzaBarcode(cardNo: string) {
    var self = this;
    self.srcBarcode = null;
    let barcodeCardNo: string = cardNo;
    if(cardNo.length < 13){

      barcodeCardNo = this.commonService.getCardWithCheckdigit(barcodeCardNo);

      /*
      this.srvLoyaltyReservations.getCardCheckDigit(barcodeCardNo).subscribe(res => {
        //console.log('check digit res ', res);
        if(res && res.length == 13){
          barcodeCardNo = res;
        }
      });
      */

    }
    setTimeout(function(){
      self.srcBarcode = self.sanitizer.bypassSecurityTrustResourceUrl(self.getBarcodeImageByCardNo(barcodeCardNo));
      self.showBarcodeModal = true;
    },200);
  }

  edit(card: Card) {
    this.router.navigate(['/loyalty/card/form/edit', card.id]);
  }

  add() {
    this.router.navigate(['/loyalty/card/form/edit']);
  }

  open(card: Card) {
    this.router.navigate(['loyalty/card/form/read', card.id]);
  }

  goToCustomer(card: Card) {
    if (this.mdmCardPermission) {
      if (card.isCompany === 'S') {
        this.router.navigate(['/customer-company', card.card_no, card.customerHostId, card.vCustomerId]);
      } else {
        this.router.navigate(['/customers-details', card.card_no, card.customerHostId, card.vCustomerId]);
      }
    } else {
      if (card.isCompany === 'S') {
        this.router.navigate(['/customer-company', card.customerHostId, card.vCustomerId]);
      } else {
        this.router.navigate(['/customers-details', card.customerHostId, card.vCustomerId]);
      }
    }

  }

  onBlacklistFileUpload(event, form) {
    this.stringaEsito = '';
    if (event.files.length !== 1) {
      this.notifyService.clear();
      this.notifyService.add({ severity: 'error', detail: 'Cannot use multiple files.' });
      this.blacklistFile = null;
      form.clear();
      throw new Error('Cannot use multiple files');
    } else {
      this.form = form;
      this.blacklistFile = event.files[0];
    }
  }

  runImportBlacklist(form) {
    this.blacklisted = [];
    let errorCount = 0;

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.blacklistData = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));

      let blacklistObs: Map<string, Observable<Card>> = new Map<string, Observable<Card>>();

      this.stringaEsito = '';

      this.blacklistData.slice(1).forEach(row => {
        if (!row || row[0] === undefined || row[0] === null) { return; }
        let card = row[0].toString();
        if (!blacklistObs.has(card)) {
          blacklistObs.set(card, this.cardService.blacklistCard(card));
        }
      });

      let size = 0;

      blacklistObs.forEach( (call, cardNo) => {
        setTimeout(() => {
          call.subscribe( res => {
            if (res && res.card_no) {
              this.blacklisted.push(res.card_no);
              this.stringaEsito += 'Card ' + cardNo + ': OK! Card correctly blacklisted\n';
            }
            if (size === blacklistObs.size - 1) {
              this.stampaMsg();
            }
            size++;
          },
        (error) => {
            this.stringaEsito += 'Card ' +  cardNo + ': ' + error + '\n';
            if (size === blacklistObs.size - 1) {
              this.stampaMsg();
            }
            size++;
            errorCount++;
          });
        }, 50);
      });
    };

    if (this.blacklistFile != null) {
      reader.readAsBinaryString(this.blacklistFile);
    }

    this.form = form;
    this.blacklistFile = null;
  }

  stampaMsg() {
    this.notifyService.clear();
    this.notifyService.add({ severity: 'info', detail: 'Import has succesfully Blacklisted ' + this.blacklisted.length + ' cards.' });
    this.newDataAvailable = true;
  }

  closeDialog() {
    this.stringaEsito = '';
    this.viewImportDialog = false;
    this.blacklistFile = null;
    if (this.form) {
      this.form.clear();
    }
  }

  copyToClipboard() {
    let text = document.getElementById('textarea') as HTMLInputElement;
    text.select();
    document.execCommand('copy');
    this.notifyService.clear();
    this.notifyService.add({ severity: 'info', detail: 'Copiato negli appunti.' });
  }

  isBlacklistedCard(card: Card) {
    // nel raro caso che il flag sia undefined, la carta NON è da grigiare
    return card && card.flg_blk_lst && card.flg_blk_lst !== '0';
  }

  isReplaceable(card: Card) {
    let res = false;
    if (card && card.vCustomerId && card.vCustomerId > 0) {
      res = true;
    }
    // return card.vCustomerId && !card.customerHostId;
    return res;
  }

  showReplaceCardModal(card: Card) {
    this.cardToReplace = card;
    this.newCardReplace = '';
    this.showReplaceModal = true;
  }

  showBlackListCardModal(card: Card) {
    this.selectedBlackListReason = this.blacklistReasons[0].value;
    this.cardToBlacklistId = card.id;
    this.cardToBlacklistNo = card.card_no;
    this.showBlackListModal = true;
  }

  showDomiciliationCardModal(card: Card) {
    this.showDomiciliationModal = true;
    this.selectedCard = card;

    this.svcStores.getListFilteredByChannel(this.selectedCard.channel_id).subscribe(stores => {
      this.filteredStoresByChannel = stores
    })

    this.svcStores.get(this.selectedCard.store_id).subscribe(currentStore => {
      this.currentStore = currentStore;
    })

  }

  undoDomiciliation() {
    this.showDomiciliationModal = false;
    this.selectedCard = null;
  }

  performDomiciliation(store_id) {

    console.log(this.selectedCard, store_id)

    this.cardService.domiciliate({
      card_id: this.selectedCard.id,
      store_from: this.selectedCard.store_id,
      store_to: store_id
    }).subscribe(res => {
      this.showDomiciliationModal = false;
      this.tService.get(['card.domiciliation_ok']).subscribe(t => {
          this.notifyService.add({
            severity: 'success',
            detail: t['card.domiciliation_ok']
          })
        })
    })
  }

  filterCardSingle(event) {
    this.customerCardService.getAvailableCards(event.query, this.cardToReplace?this.cardToReplace.channel_id:null).subscribe(filtered => {
      if (filtered.length === 0) {
        this.substitutionDisabled.cardSelected = false;
        if (event.query.length > 0) {
          this.cardNotAvailable = true;
        } else {
          this.cardNotAvailable = false;
        }
      } else {
        this.substitutionDisabled.cardSelected = true;
        this.cardNotAvailable = false;
      }
      this.cardsModal = filtered;
    });
  }

  blacklistCard(reason, table) {

    const blacklistmodel: ApiBlacklistCardModel = {
      cardId: this.cardToBlacklistId,
      cardNo: this.cardToBlacklistNo,
      blackListDate: null,
      blackListTime: null,
      reasonId: reason.value
    };

    if (!this.addCardPermission) {
      let notSameCustomer = false;
      this.customerCardService.getCustomerByCardNo(this.cardToBlacklistNo, this.userWithoutPermissions.surname, this.userWithoutPermissions.name, this.userWithoutPermissions.birthDate).subscribe(
        res => {
          if (!res) {
            this.confirmationService.confirm({
              message: this.koMsg,
              acceptLabel: 'Ok',
              rejectVisible: false
            });
            notSameCustomer = true;
          }
        },
        err => {
          console.log('!!!!!!!!!!!!!!!!', err);
          this.confirmationService.confirm({
            message: this.koMsg,
            acceptLabel: 'Ok',
            rejectVisible: false
          });
          return;
        },
        () => {
          if (notSameCustomer) {
            return;
          }
          this.sendCardToBlacklist(this.cardToBlacklistId, blacklistmodel, table);
        }
      )
    } else {
      this.sendCardToBlacklist(this.cardToBlacklistId, blacklistmodel, table);
    }
  }

  sendCardToBlacklist(cardToBlacklistId, blacklistmodel, table) {
    this.customerCardService.blacklistCard(cardToBlacklistId, blacklistmodel).subscribe( () => {
      this.closeBlacklistModal();
      this.cardToBlacklistId = null;
      this.cardToBlacklistNo = null;
      this.cardService.list().subscribe(
        res => res,
        error => console.error(error),
        () => table.refresh()
      );
    });
  }

  closeBlacklistModal() {
    this.showBlackListModal = false;
    this.userWithoutPermissions = { surname: '', name: '', birthDate: '' };
  }

  confirm(replaceReason) {
    this.confirmationService.confirm({
      message: this.confirmationMsg,
      accept: () => this.replaceCard(replaceReason)
    }
  )};

  /**
   * Sostituisce una vecchia carta con una nuova, richiamando il metodo 'substituteCardAdvanced' di customerCardService inviando,
   * come argomenti:
   *    id nuova carta;
   *    id vecchia carta;
   *    il motivo della sostituzione;
   * @param replaceReason;
  */
  replaceCard(replaceReason) {
    if (this.newCardReplace && this.cardToReplace) {
      let newCardNo: string = typeof this.newCardReplace === 'string' || this.newCardReplace instanceof String ? this.newCardReplace : this.newCardReplace.cardNo;
      let newCardId: number = typeof this.newCardReplace === 'string' || this.newCardReplace instanceof String ? null : this.newCardReplace.cardId;
      if (typeof this.newCardReplace === 'string' || this.newCardReplace instanceof String) {
        this.cardsModal.forEach(cm => {
          if (cm.cardNo === newCardNo) {
            newCardId = cm.cardId;
          }
        })
      }
      const scm: SubstituteCardModel = {
        newCardId: newCardId ? newCardId : null,
        newCardNo: newCardNo,
        oldCardId: +this.cardToReplace.id,
        oldCardNo: this.cardToReplace.card_no,
        reasonId: replaceReason.value
      };
      if (!this.addCardPermission) {
        let notSameCustomer = false;
        this.customerCardService.getCustomerByCardNo(this.cardToReplace.card_no, this.userWithoutPermissions.surname, this.userWithoutPermissions.name, this.userWithoutPermissions.birthDate).subscribe(
          res => {
            if (!res) {
              this.confirmationService.confirm({
                message: this.koMsg,
                acceptLabel: 'Ok',
                rejectVisible: false
              });
              notSameCustomer = true;
            }
          },
          err => {
            this.confirmationService.confirm({
              message: this.koMsg,
              acceptLabel: 'Ok',
              rejectVisible: false
            });
            return;
          },
          () => {
            if (notSameCustomer) {
              return;
            }
            this.substituteCard(scm);
          }
        )
      } else {
        this.substituteCard(scm);
      }
    }
  }
  onClickScaricaModuloVuoto(){
    if(this.customerType == "N"){
      this.scaricaModuloVuotoPrivato();
    }
    else if (this.customerType == "S"){
      this.scaricaModuloVuotoCompany();
    }
  }
  scaricaModuloVuotoCompany() {
    console.log('Genera report sostituzione carta - company ', this.customerAzienda);
    // Change report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;


    this.viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
    var stiReport = new Stimulsoft.Report.StiReport();

    stiReport.loadFile("./assets/report/SostituzioneCartaAzienda.mrt");

    //negozio
    stiReport.dictionary.variables.getByName("var_store_name_val").valueObject = this.customerAzienda["storeDescription"];
    stiReport.dictionary.variables.getByName("var_store_code_val").valueObject = this.customerAzienda["storeCode"];

    //carta
    stiReport.dictionary.variables.getByName("var_card_title").valueObject = this.translations['reportMgCompany.card_title'];

    stiReport.dictionary.variables.getByName("var_substitute_title").valueObject = this.translations['reportMg.substitute_title'];
    stiReport.dictionary.variables.getByName("var_substitute_val").valueObject = this.barcodeCardNoOld.toString();

    if(this.barcodeCardNoNew.toString().length == 13){
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.barcodeCardNoNew.toString());
    }else{
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo('');
    }

    //info cliente azienda
    stiReport.dictionary.variables.getByName("var_companyname_title").valueObject = this.translations['reportMgCompany.companyname_title'];
    stiReport.dictionary.variables.getByName("var_companyname_val").valueObject = this.customerAzienda.ragioneSociale;

    stiReport.dictionary.variables.getByName("var_pivafiscalcode_title").valueObject = this.translations['reportMgCompany.pivafiscalcode_title'];
    stiReport.dictionary.variables.getByName("var_pivafiscalcode_val").valueObject = this.customerAzienda.partitaIva_codiceFiscale;

    stiReport.dictionary.variables.getByName("var_officeemail_title").valueObject = this.translations['reportMgCompany.officeemail_title'];
    stiReport.dictionary.variables.getByName("var_officeemail_val").valueObject = this.customerAzienda.emailAziendale;

    stiReport.dictionary.variables.getByName("var_officemobile_title").valueObject = this.translations['reportMgCompany.officemobile_title'];
    stiReport.dictionary.variables.getByName("var_officemobile_val").valueObject = this.customerAzienda.mobileAziendale;

    stiReport.dictionary.variables.getByName("var_area_title").valueObject = this.translations['reportMgCompany.area_title'];
    stiReport.dictionary.variables.getByName("var_area_val").valueObject = this.customerAzienda.settore;

    stiReport.dictionary.variables.getByName("var_fullname_title").valueObject = this.translations['reportMgCompany.fullname_title'];
    stiReport.dictionary.variables.getByName("var_fullname_val").valueObject = this.customerAzienda.nome + ' ' + this.customerAzienda.cognome;

    stiReport.dictionary.variables.getByName("var_fiscalcode_title").valueObject =this.translations['reportMgCompany.fiscalcode_title'];
    stiReport.dictionary.variables.getByName("var_fiscalcode_val").valueObject = this.customerAzienda.fiscalCode;

    stiReport.dictionary.variables.getByName("var_street_title").valueObject = this.translations['reportMgCompany.street_title'];
    stiReport.dictionary.variables.getByName("var_street_val").valueObject = this.customerAzienda.address + " " + this.customerAzienda.addressNumber;

    stiReport.dictionary.variables.getByName("var_localita_title").valueObject = this.translations['reportMgCompany.localita_title'];
    stiReport.dictionary.variables.getByName("var_localita_val").valueObject = this.customerAzienda.comune;

    stiReport.dictionary.variables.getByName("var_province_title").valueObject = this.translations['reportMgCompany.province_title'];
    stiReport.dictionary.variables.getByName("var_province_val").valueObject = this.customerAzienda["provinceName"] ? this.customerAzienda["provinceName"] : "";

    stiReport.dictionary.variables.getByName("var_zipcode_title").valueObject = this.translations['reportMgCompany.zipcode_title'];;
    stiReport.dictionary.variables.getByName("var_zipcode_val").valueObject = this.customerAzienda.zipCode;

    //informativa
    stiReport.dictionary.variables.getByName("var_informativa_title").valueObject = this.translations['reportMgCompany.informativa_title'];
    stiReport.dictionary.variables.getByName("var_informativa_val").valueObject = (this.customerAzienda.flgAuth1 == true || this.customer.flgAuth1 == "1") ? "X" : "";

    //consenso prima riga
    stiReport.dictionary.variables.getByName("var_consenso1_title1").valueObject = this.translations['reportMgCompany.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso1_val1").valueObject = (this.customerAzienda.flgAuth2 == true || this.customerAzienda.flgAuth2 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title2").valueObject = this.translations['reportMgCompany.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso1_val2").valueObject = (!this.customerAzienda.flgAuth2 || this.customerAzienda.flgAuth2 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title3").valueObject = this.translations['reportMgCompany.consenso1_title3'];

    //consenso seconda riga
    stiReport.dictionary.variables.getByName("var_consenso2_title1").valueObject = this.translations['reportMgCompany.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso2_val1").valueObject = (this.customerAzienda.flgAuth3 == true || this.customerAzienda.flgAuth3 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title2").valueObject = this.translations['reportMgCompany.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso2_val2").valueObject = (!this.customerAzienda.flgAuth3 || this.customerAzienda.flgAuth3 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title3").valueObject = this.translations['reportMgCompany.consenso2_title3'];

    //data e firma
    stiReport.dictionary.variables.getByName("var_currentdate_title").valueObject = this.translations['reportMgCompany.currentdate_title'];
    stiReport.dictionary.variables.getByName("var_currentdate_val").valueObject = moment(new Date()).format("DD/MM/YYYY");
    stiReport.dictionary.variables.getByName("var_sign_title").valueObject = this.translations['reportMgCompany.sign_title'];

    //Render report
    stiReport.render();
    this.viewer.report = stiReport;

    // Export and Download to PDF
    this.viewer.report.exportDocumentAsync((pdfData) => {
      var buffer = Buffer.from(pdfData)
      var blob = new Blob([buffer], {type: "application/pdf"});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = this.basicInfo ? (this.basicInfo.customerCode + "_" + moment(new Date()).format('DD_MM_YYYY') + ".pdf") : "report-sostituzione-carta-azienda.pdf";
      link.download = fileName;
      link.click();
      console.log("Rendered report saved into PDF-file.");
    }, Stimulsoft.Report.StiExportFormat.Pdf);
  }

  scaricaModuloVuotoPrivato() {

    console.log('Genera report sostituzione carta - Loyalty - Card ');
    // Change report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;


    this.viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
    var stiReport = new Stimulsoft.Report.StiReport();

    stiReport.loadFile("./assets/report/SostituzioneCarta.mrt");


    //negozio
    stiReport.dictionary.variables.getByName("var_store_name_val").valueObject = this.customer["storeDescription"];
    stiReport.dictionary.variables.getByName("var_store_code_val").valueObject = this.customer["storeCode"];

    //carta
    stiReport.dictionary.variables.getByName("var_card_title").valueObject = this.translations['reportMg.card_title'];

    stiReport.dictionary.variables.getByName("var_substitute_title").valueObject = this.translations['reportMg.substitute_title'];
    stiReport.dictionary.variables.getByName("var_substitute_val").valueObject = this.barcodeCardNoOld.toString();

    if(this.barcodeCardNoNew.toString().length == 13){
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.barcodeCardNoNew.toString());
    }else{
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo('');
    }




    //info cliente
    stiReport.dictionary.variables.getByName("var_name_title").valueObject = this.translations['reportMg.name_title'];
    stiReport.dictionary.variables.getByName("var_name_val").valueObject = this.customer.nome;

    stiReport.dictionary.variables.getByName("var_surname_title").valueObject = this.translations['reportMg.surname_title'];
    stiReport.dictionary.variables.getByName("var_surname_val").valueObject = this.customer.cognome;

    stiReport.dictionary.variables.getByName("var_fiscalcode_title").valueObject = this.translations['reportMg.fiscalcode_title'];
    stiReport.dictionary.variables.getByName("var_fiscalcode_val").valueObject = this.customer.fiscalCode;

    stiReport.dictionary.variables.getByName("var_birthdate_title").valueObject = this.translations['reportMg.birthdate_title'];
    stiReport.dictionary.variables.getByName("var_birthdate_val").valueObject = moment(this.customer.birthDate).format("DD/MM/YYYY");

    stiReport.dictionary.variables.getByName("var_email_title").valueObject = this.translations['reportMg.email_title'];
    stiReport.dictionary.variables.getByName("var_email_val").valueObject = this.customer.email;

    stiReport.dictionary.variables.getByName("var_cellphone_title").valueObject =this.translations['reportMg.cellphone_title'];
    stiReport.dictionary.variables.getByName("var_cellphone_val").valueObject = this.customer.mobile;

    stiReport.dictionary.variables.getByName("var_street_title").valueObject = this.translations['reportMg.street_title'];
    stiReport.dictionary.variables.getByName("var_street_val").valueObject = this.customer.address + " " + this.customer.addressNumber;

    stiReport.dictionary.variables.getByName("var_localita_title").valueObject = this.translations['reportMg.localita_title'];
    stiReport.dictionary.variables.getByName("var_localita_val").valueObject = this.customer.comune;

    stiReport.dictionary.variables.getByName("var_province_title").valueObject = this.translations['reportMg.province_title'];
    stiReport.dictionary.variables.getByName("var_province_val").valueObject = this.customer["provinceName"] ? this.customer["provinceName"] : "";

    stiReport.dictionary.variables.getByName("var_zipcode_title").valueObject = this.translations['reportMg.zipcode_title'];;
    stiReport.dictionary.variables.getByName("var_zipcode_val").valueObject = this.customer.zipCode;

    //informativa
    stiReport.dictionary.variables.getByName("var_informativa_title").valueObject = this.translations['reportMg.informativa_title'];
    stiReport.dictionary.variables.getByName("var_informativa_val").valueObject = (this.customer.flgAuth1 == true || this.customer.flgAuth1 == "1") ? "X" : "";

    //consenso prima riga
    stiReport.dictionary.variables.getByName("var_consenso1_title1").valueObject = this.translations['reportMg.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso1_val1").valueObject = (this.customer.flgAuth2 == true || this.customer.flgAuth2 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title2").valueObject = this.translations['reportMg.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso1_val2").valueObject = (!this.customer.flgAuth2 || this.customer.flgAuth2 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title3").valueObject = this.translations['reportMg.consenso1_title3'];

    //consenso seconda riga
    stiReport.dictionary.variables.getByName("var_consenso2_title1").valueObject = this.translations['reportMg.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso2_val1").valueObject = (this.customer.flgAuth3 == true || this.customer.flgAuth3 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title2").valueObject = this.translations['reportMg.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso2_val2").valueObject = (!this.customer.flgAuth3 || this.customer.flgAuth3 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title3").valueObject = this.translations['reportMg.consenso2_title3'];

    //data e firma
    stiReport.dictionary.variables.getByName("var_currentdate_title").valueObject = this.translations['reportMg.currentdate_title'];
    stiReport.dictionary.variables.getByName("var_currentdate_val").valueObject = moment(new Date()).format("DD/MM/YYYY");
    stiReport.dictionary.variables.getByName("var_sign_title").valueObject = this.translations['reportMg.sign_title'];

    //Render report
    stiReport.render();
    this.viewer.report = stiReport;

    // Export and Download to PDF
    this.viewer.report.exportDocumentAsync((pdfData) => {
      var buffer = Buffer.from(pdfData)
      var blob = new Blob([buffer], {type: "application/pdf"});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = this.basicInfo ? (this.basicInfo.customerCode + "_" + moment(new Date()).format('DD_MM_YYYY') + ".pdf") : "report-sostituzione-carta-azienda.pdf";
      link.download = fileName;
      link.click();

      console.log("Rendered report saved into PDF-file.");
    }, Stimulsoft.Report.StiExportFormat.Pdf);
  }

  getBarcodeImageByCardNo(cardNo: string){

    var JsBarcode = require('jsbarcode')

    JsBarcode("#barcode", cardNo, {
      format: "EAN13",
      lineColor: "#000",
      width:2,
      height:40,
      displayValue: true
    });

    var svg = $("#barcode")[0];

    var xml = new XMLSerializer().serializeToString(svg);

    var base64 = 'data:image/svg+xml;base64,' + btoa(xml);

    return base64;
  }

  substituteCard(card) {

    if(this.mgPermission){
      let searchCard = [
        {key: 'card_no',value: this.cardToReplace.card_no.toString()}
      ];

      this.srvCustomer.list(null,null,searchCard).subscribe(res=>{

        if(res && res.data && res.data.length && res.data.length==1){
          this.customerType = res.data[0].flg_company;
          if(this.customerType == "N"){
            this.substituteCardCustomer(res.data[0].id,card);
          }
          else if(this.customerType == "S"){
            this.substituteCardCompany(res.data[0].id,card);
          }

        }
      });
    }
    else{
      this.customerCardService.substituteCardAdvanced(card).subscribe((res) => {
        this.showReplaceModal = false;
      });
    }

/*
    this.customerCardService.substituteCardAdvanced(card).subscribe((res) => {
      this.showReplaceModal = false;
    })
*/
  }
  substituteCardCompany(customerHostId,card){

    //recupero dati
    let search = [
      {key: 'name',value: 'italia' },
      {key: 'flg_state',value: '0'}
    ];

    var COUNTRIES = this.srvCountry.list(null,null,search);
    var GETCLASSIFICATIONINFO = this.srvInfoCust.getClassification(customerHostId);
    var GETBASICINFO = this.srvInfoCust.getBasicInfo(customerHostId);
    var GETCOMPANYINFO = this.srvCustomer.getCompanyData(customerHostId);
    var GETCARDSINFO = this.srvInfoCust.getCards(customerHostId);
    var SUBSTITUTE = this.customerCardService.substituteCardAdvanced_success(card);
    var self = this;

    Observable.zip(
      GETCLASSIFICATIONINFO,
      COUNTRIES,
      GETBASICINFO,
      GETCARDSINFO,
      GETCOMPANYINFO,
      SUBSTITUTE
      )
    .subscribe(([
      resClassificationInfo,
      resCountries,
      resBasicInfo,
      resCardInfo,
      resCompanyInfo,
      resSubstitute
    ]) => {

      if(resSubstitute && resSubstitute.success){

        this.show.substitutionOk = true;

        let provinces: Observable<any>;

        if(resCountries){
          if(resCountries.data[0] !== null) {
            provinces = self.srvProvince.getAll(resCountries.data[0].id);
          } else {
            provinces = self.srvProvince.getAll(-1);
          }

          provinces.subscribe(resProvinces=>{
            if(resProvinces){
              for (const province of resProvinces) {
                self.provinces.push({
                  value: province.id,
                  label: province.name
                });
              }
            }
            if(resBasicInfo && resCardInfo && resCompanyInfo){
              this.basicInfo = resBasicInfo;
              let cust:mgCustomerCompany = new mgCustomerCompany();
              //let basicInfo: CustomerBasicInfo;
              //let companyInfo: Array<CustomerCompanyData>;
              let classificationInfo: Array<any>;
           //   let cardInfo: Array<CustomerCardListModel>;

              if(resBasicInfo.customerCode){
                //console.log('this.basicInfo ', this.basicInfo);
                //console.log('resCompanyInfo ', resCompanyInfo);
                //console.log('resClassificationInfo ', resClassificationInfo);
                //basicInfo = resBasicInfo;
                //companyInfo = resCompanyInfo ? resCompanyInfo : null;
                classificationInfo = resClassificationInfo ? resClassificationInfo : null;
                //cardInfo = resCardsInfo;

                cust.ragioneSociale = resCompanyInfo[0].companyInfo !== null ? resCompanyInfo[0].company_name : '';
                cust.partitaIva_codiceFiscale = resCompanyInfo !== null ? resCompanyInfo[0].vat_code !== '' ? resCompanyInfo[0].vat_code : resCompanyInfo[0].fiscal_code : '';
                cust.emailAziendale = resCompanyInfo !== null ? resCompanyInfo[0].email_primary : '';
                cust.mobileAziendale = resCompanyInfo !== null ? resCompanyInfo[0].phone_mobile : '';
                if(classificationInfo !== null){
                  this.classificationService.getTypes('customer').switchMap(classificationTypes => {
                    return this.classificationService.getList(classificationTypes[0].id);
                  }).subscribe(classifications => {
                    this.classificationService.getDetails(classifications[0].id).subscribe(res => {
                      for (const classification of res) {
                        this.settore.push({ label: classification.description, value: classification.id });
                      }
                      if(this.settore.length > 0){
                        cust.settore = this.settore.find(f => f.value.toString() === classificationInfo[0].classification_detail_id.toString()) === undefined ? '' : this.settore.find(f => f.value.toString() === classificationInfo[0].classification_detail_id.toString()).label;
                      }
                    });
                  });
                }else{
                  cust.settore = '';
                }
                cust.nome = resBasicInfo.name;
                cust.cognome = resBasicInfo.surname;
                cust.fiscalCode = resBasicInfo.fiscal_code;
                cust.address = resBasicInfo.address;
                cust.addressNumber = resBasicInfo.address_number;
                cust.comune = resBasicInfo.city;
                cust.zipCode = resBasicInfo.zip_code;
                cust.province = resBasicInfo.province_id;
                cust.flgAuth1 = resBasicInfo.flag_privacy;
                cust.flgAuth2 = resBasicInfo.flag_marketing_activities;
                cust.flgAuth3 = resBasicInfo.flag_profiling;

                let card: CustomerCardListModel = null;
                //prendo la prima che incontro non in blacklist che sono sicuro che è l'ultima associata.
                for(var i = 0;i<resCardInfo.length;i++){
                  if(resCardInfo[i].flagBlackList!="1"){
                    card = resCardInfo[i];
                    break;
                  }
                }

                self.card = card;



                var self2 = self;

                let indexProvince = self.provinces.findIndex(x=>x.value == cust.province);
                if(indexProvince>-1){
                  cust["provinceName"] = self.provinces[indexProvince].label;
                }

                //if(self.card !== null){
                //09-05-2022 Modificato perchè in caso di carta in blacklist vale undefined e perciò passava il controllo, erroneamente

                if(self.card){
                  self.srvStoreCommon.getList(null,null,{id: card.store_id.toString()}).subscribe(res=>{

                    if(res && res.length && res.length>0){
                      cust["storeDescription"] = res[0].name;
                      cust["storeCode"] = res[0].code;
                    }

                    self2.customerAzienda = cust;

                    if(self.card.cardNo.length < 13){

                      this.barcodeCardNoOld = this.commonService.getCardWithCheckdigit(self.card.cardNo);

                      /*
                      this.srvLoyaltyReservations.getCardCheckDigit(self.card.cardNo).subscribe(res => {
                        console.log('check digit res ', res);
                        if(res && res.length == 13){
                          this.barcodeCardNoOld = res;
                        }
                      });
                      */
                    }

                    //fix per KS-3350: se si selezionava la carta veniva presa, ma se non si selezionava ma solamente digitata, non veniva presa
                    let cardNumber: string = this.newCardReplace.cardNo ? this.newCardReplace.cardNo : this.newCardReplace;

                    if(cardNumber.length < 13){

                      this.barcodeCardNoNew =  this.commonService.getCardWithCheckdigit(cardNumber);

                      /*
                      this.srvLoyaltyReservations.getCardCheckDigit(cardNumber).subscribe(res => {
                        console.log('check digit res ', res);
                        if(res && res.length == 13){
                          this.barcodeCardNoNew = res;
                        }
                      });
                      */
                    }

                    this.show.downloadSubstituteModule = true;

                  });
                }
              }
            }
          });
        }
      }

        });
  }
  substituteCardCustomer(customerHostId,card){
    let searchCountries = [
      {key: 'name',value: 'italia' },
      {key: 'flg_state',value: '0'}
    ];
    var COUNTRIES = this.srvCountry.list(null,null,searchCountries);
    var GETBASICINFO = this.srvInfoCust.getBasicInfo(customerHostId);
    var GETCARDSINFO = this.srvInfoCust.getCards(customerHostId);
    var SUBSTITUTE = this.customerCardService.substituteCardAdvanced_success(card);


    var self = this;

    Observable.zip(
      GETBASICINFO,
      GETCARDSINFO,
      COUNTRIES,
      SUBSTITUTE)
    .subscribe(([
      resBasicInfo,
      resCardsInfo,
      resCountries,
    resSubstitute]) => {

      if(resSubstitute && resSubstitute.success){

        this.show.substitutionOk = true;

        let provinces: Observable<any>;

        if(resCountries){
          if(resCountries.data[0] !== null) {
            provinces = self.srvProvince.getAll(resCountries.data[0].id);
          } else {
            provinces = self.srvProvince.getAll(-1);
          }

          provinces.subscribe(resProvinces=>{
            if(resProvinces){
              for (const province of resProvinces) {
                self.provinces.push({
                  value: province.id,
                  label: province.name
                });
              }
            }

            if(resBasicInfo && resCardsInfo){

              let cust:mgCustomer = new mgCustomer();
              let basicInfo: CustomerBasicInfo;
              let cardInfo: Array<CustomerCardListModel>;

              if(resBasicInfo.customerCode){
                basicInfo = resBasicInfo;
                cardInfo = resCardsInfo;
                cust.customerId = +customerHostId;
                cust.puntoVenditaPref = (resBasicInfo && resBasicInfo.preferred_store_id) ? resBasicInfo.preferred_store_id.toString() : "1";
                cust.nome = basicInfo.name;
                cust.cognome = basicInfo.surname;
                cust.fiscalCode = basicInfo.fiscal_code;
                cust.birthDate = basicInfo.birthday;
                cust.sex = basicInfo.sex;
                cust.mobile = basicInfo.phone_mobile;
                cust.email = basicInfo.email_primary;
                cust.toponym = (basicInfo && basicInfo.toponym_id) ? basicInfo.toponym_id.toString() : "1";
                cust.address = basicInfo.address;
                cust.addressNumber = basicInfo.address_number;
                cust.comune = basicInfo.city;
                cust.zipCode = basicInfo.zip_code;
                cust.province = basicInfo.province_id;
                cust.flgAuth1 = basicInfo.flag_privacy;
                cust.flgAuth2 = basicInfo.flag_marketing_activities;
                cust.flgAuth3 = basicInfo.flag_profiling;

                let card: CustomerCardListModel = null;
                //prendo la prima che incontro non in blacklist che sono sicuro che è l'ultima associata.
                for(var i = 0;i<cardInfo.length;i++){
                  if(cardInfo[i].flagBlackList!="1"){
                    card = cardInfo[i];
                    break;
                  }
                }

                self.card = card;
                var self2 = self;

                let indexProvince = self.provinces.findIndex(x=>x.value == cust.province);
                if(indexProvince>-1){
                  cust["provinceName"] = self.provinces[indexProvince].label;
                }

                self.srvStoreCommon.getList(null,null,{id: card.store_id.toString()}).subscribe(res=>{

                  if(res && res.length && res.length>0){
                    cust["storeDescription"] = res[0].name;
                    cust["storeCode"] = res[0].code;
                  }

                  self2.customer = cust;
                });

                if(self.card.cardNo.length < 13){

                  this.barcodeCardNoOld =  this.commonService.getCardWithCheckdigit(self.card.cardNo);

                  /*
                  this.srvLoyaltyReservations.getCardCheckDigit(self.card.cardNo).subscribe(res => {
                    console.log('check digit res ', res);
                    if(res && res.length == 13){
                      this.barcodeCardNoOld = res;
                    }
                  });
                  */
                }

                //fix per KS-3350: se si selezionava la carta veniva presa, ma se non si selezionava ma solamente digitata, non veniva presa
                let cardNumber: string = this.newCardReplace.cardNo ? this.newCardReplace.cardNo : this.newCardReplace;

                if(cardNumber.length < 13){
                  this.barcodeCardNoNew =  this.commonService.getCardWithCheckdigit(cardNumber);
                  /*
                  this.srvLoyaltyReservations.getCardCheckDigit(cardNumber).subscribe(res => {
                    console.log('check digit res ', res);
                    if(res && res.length == 13){
                      this.barcodeCardNoNew = res;
                    }
                  });
                  */
                }

                this.show.downloadSubstituteModule = true;
              }
            }

          });
        }

      }
    });
  }
  reasonSelectedHandler() {
    if (!this.substitutionDisabled.reasonSelected) {
      this.substitutionDisabled.reasonSelected = true;
    }
  }

  closeReplaceModal(replaceReason) {
    /*** azzeramento variabili per il download del modulo da stampare ***/
    this.show.downloadSubstituteModule = false;
    this.file = null;
    this.provinces = [];
    this.customerInfo = null;
    this.card = null;
    this.customer = null;
    this.barcodeCardNoOld = "";
    this.barcodeCardNoNew = "";
    this.show.substitutionOk = false;

    this.showReplaceModal = false;
    replaceReason.clear();
    this.substitutionDisabled.cardSelected = false;
    this.substitutionDisabled.reasonSelected = false;
    this.userWithoutPermissions = { surname: '', name: '', birthDate: '' };
    this.cardNotAvailable = false;
  }
  movementSaved(isSaved) {
    this.movementCardId = 0;
    this.showMovementForm = false;
  }
  onClickAddMovement(card) {
    this.movementCardId = card.id;
    this.showMovementForm = true;
  }

  downloadExcel(filters) {
    this.cardService.getExcelFilename(filters).subscribe(
      filename => {
        if (this.cardDownloadPermission) {
          this.cardService.downloadExcel(filename).subscribe(res => {
            FileSaver.saveAs(res, filename);
          })
        } else {
          return;
        }
      },
      error => console.error(error)
    );
  }

  /**
   * Filtro data prenotazione
   */
   onChangeDateCard(field) {
    if (this.filterDateCard) {
      this.table.updateTableFilter(field, this.commonService.fromDateToDBString(this.filterDateCard), 'equals');
    } else {
      let index = this.table.filter.search.findIndex(f => f.key === field);
      if (index > -1) {
        this.table.filter.search.splice(index, 1);
        this.table.refresh();
      }
    }
  }

  sendExtSearchQuery(event) {
    /*
      Azzero totalRecords perchè, in caso di svuotamento della table e successiva
      ripetizione della medesima ricerca, il valore non risulterebbe aggiornato e,
      di conseguenza, causerebbe errori di paginazione
    */
    this.totalRecords = 0;
    const params = {query: event.query, offset: event.offset, limit: event.limit};
    if (event.sortField && event.sortDir) {
      Object.assign(params, {sortField: event.sortField, sortDir: event.sortDir});
    }
    this.cardService.sendExtSearchQuery(params).subscribe(res => {
      this.extSearchResult = res.data;
      this.totalRecords = res.metadata.total;
    });
  }

  downloadPdf(pdfUrl) {
    window.open(pdfUrl);
  }

  goToCustomerBalance(event) {
    if (event.flg_blk_lst !== '1' && event.flg_state !== '1') {
      this.router.navigate([`loyalty/balance/${event.vCustomerId}`]);
    }
  }

  oblivionCustomer(customerId: number) {
    this.confirmationService.confirm({
      header: this.translate.instant('customerOblivion.confirmOblivionHeader'),
      message: this.translate.instant('customerOblivion.confirmOblivionMessage'),
      acceptLabel: 'OK',
      rejectLabel: this.translate.instant('common.cancel'),
      accept: () =>
        this.customerOblivionService.oblivionCustomer(customerId).subscribe(() => {
          this.notifyService.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
          this.newDataAvailable = true
        }),
      rejectVisible: true
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card/loyalty-card.component.ts